export default {
    BILLING_ADDRESS_FORM: 'billingAddress',
    SHIPPING_ADDRESS_FORM: 'shippingAddress',
};
